<button mat-button type="button" [matMenuTriggerFor]="info" (click)="$event.stopPropagation(); $event.preventDefault()">
  <span>{{ notice() }}</span>
</button>

<mat-menu #info="matMenu" xPosition="before">
  <ideal-item-price-sale-and-fees-info-view [pricing]="pricing()" [multiplyBy]="multiplyBy()" />
</mat-menu>
